import {
	User,
	UsersApi,
	UsersUserIdRolesDataActionEnum as RoleActions,
	UsersUserIdRolesDataRoleEnum as OrgRole,
} from '@/api';
import { ApiUtils } from '@/common/ApiUtils';
import { AxiosError, AxiosResponse } from 'axios';
import { AddNewUserService } from './add-new-user-service';

export class AddOrgRoleService extends AddNewUserService {
	public selectedRole: string | null = null;
	private roles = [
		{ value: 'partner.admin', text: 'Partner Admin', type: 'partner' },
		{ value: 'partner.user', text: 'Partner Read Only', type: 'partner' },
		{ value: 'org.admin', text: 'Organisation Admin', type: 'org' },
	];

	public get roleOptions(): {
		value: string;
		text: string;
		type: string;
	}[] {
		return this.roles.filter(role => role.type === this.orgType);
	}

	constructor(
		private orgId: number,
		private orgType: string,
		protected usersApi: UsersApi = new UsersApi(),
	) {
		super(usersApi);
	}

	public async save(): Promise<User | { error: string }> {
		if (!this.selectedRole) {
			return { error: 'No role selected' };
		}
		if (!this.user.id) {
			const createdUserResponse = await super.save();
			if ('error' in createdUserResponse) {
				return createdUserResponse;
			}
			this.updateUserValues(createdUserResponse);
		}
		const role = {
			orgId: this.orgId,
			action: RoleActions.Attach,
			role: this.selectedRole as OrgRole,
		};
		try {
			const createOrgRoleResponse = ((await this.usersApi.userRoles(this.user.id!, {
				data: role,
			})) as unknown) as AxiosResponse<{ data: User }>;
			return createOrgRoleResponse.data.data;
		} catch (e) {
			const errorResponse = ApiUtils.handleApiError(
				e as AxiosError,
				'Failed to attach user to org: unknown error',
			);
			return { error: errorResponse.errorMessage };
		}
	}

	public cancel(): void {
		super.cancel();
		this.selectedRole = null;
	}
}
